export default "__VITE_ASSET__67hqP5Yj__"